import mqtt from 'mqtt'
import store from "../store/store"

var client

export async function subscribebySubLoopUrl(subLoopUrl) {
    // if(!client){
    //     await connect()
    // }
    if (Array.isArray(subLoopUrl)) {
        subLoopUrl.forEach(item => {
            client.subscribe(`VrMaker/${store.state.db}/+/PUBLISH/${item}/#`)
            // console.log('订阅：' + `VrMaker/${store.state.db}/+/PUBLISH/${item}/#`)
        })
    } else {
        client.subscribe(`VrMaker/${store.state.db}/+/PUBLISH/${subLoopUrl}/#`)
        // console.log('订阅：' + `VrMaker/${store.state.db}/+/PUBLISH/${subLoopUrl}/#`)
    }
}

export async function unsubscribebySubLoopUrl(subLoopUrl) {
    if (Array.isArray(subLoopUrl)) {
        subLoopUrl.forEach(item => {
            client.unsubscribe(`VrMaker/${store.state.db}/+/PUBLISH/${item}/#`)
            // console.log('取消订阅：' + `VrMaker/${store.state.db}/+/PUBLISH/${item}/#`)
        })
    } else {
        client.unsubscribe(`VrMaker/${store.state.db}/+/PUBLISH/${subLoopUrl}/#`)
        // console.log('取消订阅：' + `VrMaker/${store.state.db}/+/PUBLISH/${subLoopUrl}/#`)
    }
}

function createNodeTopics(nodes) {
    return nodes.map(item => {
        if (store.state.projectId == 4) {
            // console.log('订阅：' + `VrMaker/${store.state.db}/+/PUBLISH/+/+/+/${item}#`)
            return `VrMaker/${store.state.db}/+/PUBLISH/+/+/+/${item}`
        } else {
            // console.log('订阅：' + `VrMaker/${store.state.db}/+/PUBLISH/+/+/${item}#`)
            return `VrMaker/${store.state.db}/+/PUBLISH/+/+/${item}`
        }
    })
}

export function subscribeByNodes(nodes) {
    client && client.subscribe(createNodeTopics(nodes));
}

export function unsubscribeByNodes(nodes) {
    client && client.unsubscribe(createNodeTopics(nodes));
}

export async function connect() {
    // client = mqtt.connect("mqtt://local.vrmaker.vip:8083/mqtt", {
    client = mqtt.connect("wss://local.vrmaker.com.cn:18888/mqtt", {
        username: "vrmaker",
        password: "vrmaker",
    })

    await new Promise((resolve, reject) => {
        client.on("connect", () => {
            console.log('mqtt链接成功')
            resolve();
        });
    })

    client.on("message", (topic, message) => {
        // console.log(topic,Number(message));
        let keys = topic.split('/')
        let len = keys.length
        let devicesName = keys.slice(4, len - 1).join('/')
        let topicName = keys.slice(4).join('/')

        // console.log(topicName, Number(message));
        // if(topic.includes('AMC72')){
        // console.log(topic,Number(message));

        // }

        store.commit("addMQTTData", {
            key: topicName,
            val: message,
        })
    })

    client.on("error", (err) => {
        console.log("mqtt error !!!", err)
        client.end()
    })

    client.on("close", () => {
        console.log("mqtt closed!")
    })
}

export async function destroyConnection() {
    if (client) {
        try {
            client.end()
            client = null
            console.log('Successfully disconnected!')
        } catch (error) {
            console.log('Disconnect failed', error.toString())
        }
    }
}